module.exports = __webpack_public_path__ + "img/about-icon-2.c8b82f36.svg";